'use client'

import styles from "./PhotographerHeader.module.css";
import Image from "next/image";
import { useState } from "react";

export default function PhotographerHeader({photographer}){
    const [isModalOpen, setIsModalOpen] = useState(false);

    return(
        <section className={styles.photographerHeader}>
            <div className={styles.photographerPresentation}>
                <h1 className={styles.photographerName}>{photographer.name}</h1>
                <h2 className={styles.photographerLocation}>{photographer.city}, {photographer.country}</h2>
                <p className={styles.photographerTagline}>{photographer.tagline}</p>
            </div>
            <div className={styles.contactButtonWrapper}>
                <button
                    className={styles.contactButton}
                    onClick={() => setIsModalOpen(true)}
                >
                    Contactez-moi
                </button>
            </div>
            <div className={styles.portraitWrapper}>
                <Image 
                    src={"/assets/" + photographer.portrait}
                    width={200}
                    height={200}
                    className={styles.photographerPortrait}
                    alt={"Photo de " + photographer.name}
                />
            </div>
            <ContactModal
                name={photographer.name}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </section>
    )
}